import {
  SET_CUSTOMER,
  CustomerData,
  SAVE_CUSTOMER,
  GET_CUSTOMER,
  SELECTED_CARD,
  CREATE_CUSTOMER,
  CustomerCard,
} from './types';

export const setCustomer = (customers: CustomerData[]) => ({
  type: SET_CUSTOMER,
  customers,
});

export const saveCardCustomer = (customers: CustomerData) => ({
  type: SAVE_CUSTOMER,
  customers,
});

export const getCustomers = () => ({ type: GET_CUSTOMER });

export const selectCard = (selected: string) => ({
  type: SELECTED_CARD,
  selected,
});

export const createCardCustomer = (customerCard: CustomerCard) => ({
  type: CREATE_CUSTOMER,
  customerCard,
});
